import LegalLayout from './LegalLayout.jsx'

const UPDATED_AT = '21 de outubro de 2026'

const SECTIONS = [
  { id: 'objeto', title: '1. Objeto da plataforma' },
  { id: 'conta', title: '2. Cadastro e conta' },
  { id: 'responsabilidades', title: '3. Responsabilidades do usuário' },
  { id: 'uso-adequado', title: '4. Uso adequado do sistema' },
  { id: 'terceiros', title: '5. Integração com terceiros' },
  { id: 'propriedade', title: '6. Propriedade intelectual' },
  { id: 'limitacao', title: '7. Limitação de responsabilidade' },
  { id: 'suspensao', title: '8. Suspensão e encerramento' },
  { id: 'alteracoes', title: '9. Alterações dos termos' },
  { id: 'contato', title: '10. Contato' },
]

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Termos de Serviço"
      title="Termos de Serviço"
      updatedAt={UPDATED_AT}
      sections={SECTIONS}
    >
      <section id="objeto">
        <h2>
          <span className="legal-num">01</span> Objeto da plataforma
        </h2>
        <p>
          A <strong>TITAM</strong> é uma plataforma SaaS de gestão e análise de campanhas digitais. Por
          meio dela, os usuários podem conectar suas contas do Google (Google Ads e Google Calendar) e da Meta (Facebook, Instagram
          e WhatsApp), visualizar métricas, campanhas e anúncios, receber leads de anúncios no CRM e
          obter análises e insights sobre o desempenho de suas campanhas.
        </p>
        <p>
          Estes Termos de Serviço ("Termos") regem o acesso e o uso da plataforma. Ao utilizar a TITAM,
          você declara ter lido, compreendido e concordado com estes Termos e com a nossa{' '}
          <a href="/privacy">Política de Privacidade</a>.
        </p>
      </section>

      <section id="conta">
        <h2>
          <span className="legal-num">02</span> Cadastro e conta
        </h2>
        <p>
          Para utilizar a TITAM, é necessário criar uma conta e, quando aplicável, vincular-se a uma
          organização. Você é responsável por fornecer informações verdadeiras e atualizadas e por
          manter a confidencialidade das suas credenciais de acesso.
        </p>
        <ul>
          <li>Você é responsável por todas as atividades realizadas em sua conta;</li>
          <li>Deve notificar a TITAM imediatamente sobre qualquer uso não autorizado;</li>
          <li>O acesso pode estar sujeito às permissões definidas pela sua organização.</li>
        </ul>
      </section>

      <section id="responsabilidades">
        <h2>
          <span className="legal-num">03</span> Responsabilidades do usuário
        </h2>
        <p>Ao utilizar a plataforma, você se compromete a:</p>
        <ul>
          <li>Utilizar a TITAM em conformidade com a legislação aplicável e com estes Termos;</li>
          <li>Conectar apenas contas e dados sobre os quais você possui autorização legítima;</li>
          <li>Não compartilhar suas credenciais de acesso com terceiros não autorizados;</li>
          <li>Manter a segurança dos dispositivos e meios utilizados para acessar a plataforma;</li>
          <li>Responder pela veracidade e legalidade dos dados inseridos ou conectados à plataforma.</li>
        </ul>
      </section>

      <section id="uso-adequado">
        <h2>
          <span className="legal-num">04</span> Uso adequado do sistema
        </h2>
        <p>É expressamente vedado ao usuário:</p>
        <ul>
          <li>Utilizar a plataforma para fins ilícitos, fraudulentos ou não autorizados;</li>
          <li>Tentar acessar áreas, contas ou dados aos quais não tenha permissão;</li>
          <li>Realizar engenharia reversa, copiar ou explorar indevidamente o sistema;</li>
          <li>Sobrecarregar, comprometer ou interferir na infraestrutura e na segurança da plataforma;</li>
          <li>Utilizar a TITAM de forma que viole direitos de terceiros ou políticas de serviços integrados.</li>
        </ul>
      </section>

      <section id="terceiros">
        <h2>
          <span className="legal-num">05</span> Integração com serviços de terceiros
        </h2>
        <p>
          A TITAM integra-se a serviços de terceiros, em especial ao <strong>Google</strong> (Google Ads e
          Google Calendar) e à <strong>Meta</strong> (Lead Ads, Click-to-WhatsApp e API de Conversões),
          por meio do protocolo OAuth 2.0. Ao conectar tais serviços, você autoriza a plataforma a
          acessar os dados necessários para a prestação das funcionalidades, conforme descrito na{' '}
          <a href="/privacy">Política de Privacidade</a>.
        </p>
        <ul>
          <li>
            O uso dos dados obtidos das APIs do Google segue a{' '}
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Política de Dados do Usuário dos Serviços de API do Google
            </a>
            , incluindo os requisitos de Uso Limitado;
          </li>
          <li>
            Você pode revogar o acesso da TITAM à sua conta Google a qualquer momento em{' '}
            <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">
              myaccount.google.com/permissions
            </a>
            ;
          </li>
          <li>
            O uso dos dados obtidos da Meta segue os{' '}
            <a href="https://developers.facebook.com/terms/" target="_blank" rel="noopener noreferrer">
              Termos da Plataforma Meta
            </a>
            ; você pode remover o app a qualquer momento em Configurações do Facebook → Integrações
            comerciais;
          </li>
          <li>
            Você é responsável por ter base legal e, quando exigido, o consentimento dos titulares para
            os leads e contatos que capta e envia por meio dessas integrações, inclusive em formulários
            de Lead Ads e na API de Conversões;
          </li>
          <li>
            A disponibilidade e o comportamento dos serviços de terceiros estão sujeitos aos respectivos
            termos e políticas, sobre os quais a TITAM não tem controle.
          </li>
        </ul>
      </section>

      <section id="propriedade">
        <h2>
          <span className="legal-num">06</span> Propriedade intelectual
        </h2>
        <p>
          A plataforma, incluindo seu código, design, marca, layout e funcionalidades, é de
          propriedade da TITAM e está protegida pela legislação aplicável. Estes Termos não concedem ao
          usuário qualquer direito de propriedade sobre a plataforma, apenas uma licença limitada,
          não exclusiva e revogável de uso.
        </p>
        <p>
          Os dados das campanhas e contas conectadas permanecem de titularidade do usuário ou de sua
          organização.
        </p>
      </section>

      <section id="limitacao">
        <h2>
          <span className="legal-num">07</span> Limitação de responsabilidade
        </h2>
        <p>
          A TITAM é fornecida "como está" e "conforme disponível". Empregamos esforços razoáveis para
          manter a plataforma disponível, segura e precisa, mas não garantimos operação ininterrupta ou
          isenta de erros.
        </p>
        <ul>
          <li>
            A TITAM não se responsabiliza por decisões de negócio tomadas com base nas métricas e
            análises exibidas;
          </li>
          <li>
            Não nos responsabilizamos por indisponibilidades, alterações ou falhas em serviços de
            terceiros, como o Google e a Meta;
          </li>
          <li>
            Na máxima extensão permitida por lei, a TITAM não responde por danos indiretos, incidentais
            ou consequentes decorrentes do uso ou da impossibilidade de uso da plataforma.
          </li>
        </ul>
      </section>

      <section id="suspensao">
        <h2>
          <span className="legal-num">08</span> Suspensão ou encerramento de contas
        </h2>
        <p>
          Podemos suspender ou encerrar o acesso à plataforma, total ou parcialmente, em caso de
          violação destes Termos, uso indevido, risco à segurança ou exigência legal. Sempre que
          possível, você será notificado previamente.
        </p>
        <p>
          Você pode encerrar sua conta a qualquer momento. Após o encerramento, o acesso aos serviços é
          interrompido e os dados são tratados conforme a nossa{' '}
          <a href="/privacy">Política de Privacidade</a>. Para pedir a exclusão dos seus dados,
          veja as <a href="/data-deletion">instruções de exclusão de dados</a>.
        </p>
      </section>

      <section id="alteracoes">
        <h2>
          <span className="legal-num">09</span> Alterações dos termos
        </h2>
        <p>
          Podemos atualizar estes Termos periodicamente para refletir mudanças na plataforma, em
          requisitos legais ou em práticas operacionais. A data da última atualização é indicada no topo
          deste documento. O uso contínuo da plataforma após as alterações implica concordância com os
          Termos revisados.
        </p>
      </section>

      <section id="contato">
        <h2>
          <span className="legal-num">10</span> Informações de contato
        </h2>
        <p>Em caso de dúvidas sobre estes Termos de Serviço, entre em contato:</p>
        <div className="legal-contact">
          <div className="legal-contact-row">
            <strong>E-mail:</strong> <a href="mailto:deebsnow.io@gmail.com">deebsnow.io@gmail.com</a>
          </div>
          <div className="legal-contact-row">
            <strong>Plataforma:</strong> TITAM — Gestão e análise de campanhas digitais
          </div>
        </div>
      </section>
    </LegalLayout>
  )
}
